import de from './translations/de.json';

const t = {
	DE: de,
};

export const useTranslation = () => {
	return t['DE'];
};
